export default "__VITE_ASSET__DKk_jZ1a__"